import React from 'react';
import { useActiveToggleConfig } from '../../providers/activeToggleProvider';
import { useFieldController } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import styles from './index.module.scss';

const { active: activeName } = fieldNames.scheduleSettingInterval;

function ActiveToggle({ field: defaultField, index, disabled }) {
  const { createName } = useActiveToggleConfig();

  const { field } = useFieldController({
    name: createName(index),
    defaultValue: defaultField[activeName],
  });

  return (
    <input
      type="checkbox"
      checked={field.value}
      onChange={field.onChange}
      className={styles.root}
      disabled={disabled}
    />
  );
}

export default ActiveToggle;
